<template lang="pug">
  .slideshow
    .col.west
      .image
        .image-wrap
          img(:src="getWestImage")
      .actions
        ul
          li
            span press 'z' to go back
          li
            span hold 'x' to pause
          li
            span press 'c' to go foward
    .col.east
      .image
        .image-wrap
          img(:src="getEastImage")
      .actions
        ul
          li
            span press 'b' to go back
          li
            span hold 'n' to pause
          li
            span press 'm' to go foward
    .timers
      .timer.west(:style="getWestTimer")
      .timer.east(:style="getEastTimer")



</template>

<script>

const timer = 4
const step = .05
const interval = 1000 * step
console.log(interval)

export default {
  name: 'Slideshow',
  components: {
  },
  data () {
    return {
      westIndex: 1,
      westTimer: 0,
      westInterval: null,
      eastIndex: 1,
      eastTimer: 0,
      eastInterval: null
    }
  },
  mounted() {
    this.setIntervalWest()
    this.setIntervalEast()
    document.addEventListener('keyup', this.handleKeyUp)
    document.addEventListener('keydown', this.handleKeyDown)
  },
  computed: {
    getWestImage () {
      return require(`../assets/yearbook/1970East-0${this.westIndex < 10 ? '0' + this.westIndex : this.westIndex}_WEB-min.jpg`)
    },
    getEastImage () {
      return require(`../assets/yearbook/EAST_YEARBOOK-${this.eastIndex}-min.jpg`)
    },
    getWestTimer () {
      let end = this.westTimer / timer * 100
      return {backgroundImage: `linear-gradient(90deg, #4287f5 ${end}%, white ${end}%)`}
    },
    getEastTimer () {
      let end = this.eastTimer / timer * 100
      return {backgroundImage: `linear-gradient(90deg, #4287f5 ${end}%, white ${end}%)`}
    }
  },
  methods: {
    handleKeyUp (evt) {
      console.log(evt.keyCode)
      if (evt.keyCode === 90) {
        this.westBack()
      }
      if (evt.keyCode === 66) {
        this.eastBack()
      }
      if (evt.keyCode === 88) {
        this.setIntervalWest()
      }
      if (evt.keyCode === 78) {
        this.setIntervalEast()
      }
      if (evt.keyCode === 67) {
        this.westNext()
      }
      if (evt.keyCode === 77) {
        this.eastNext()
      }
    },
    handleKeyDown (evt) {
      if (evt.keyCode === 88) {
        clearInterval(this.westInterval)
      }
      if (evt.keyCode === 78) {
        clearInterval(this.eastInterval)
      }
    },
    westBack () {
      console.log('west back')
      this.westIndex = this.westIndex - 1
      if (this.westIndex < 1) {
        this.westIndex = 81
      }
      this.westTimer = 0
    },
    eastBack () {
      console.log('east back')
      this.eastIndex = this.eastIndex - 1
      if (this.eastIndex < 1) {
        this.eastIndex = 78
      }
      this.eastTimer = 0
    },
    setIntervalWest () {
      this.westInterval = setInterval(() => {
        this.westTimer = this.westTimer + step
        if (this.westTimer > timer + step) {
          this.westTimer = 0
          this.westIndex = this.westIndex + 1
          if (this.westIndex > 81) {
            this.westIndex = 1
          }
        }
      }, interval)
    },
    setIntervalEast () {
      this.eastInterval = setInterval(() => {
        this.eastTimer = this.eastTimer + step
        if (this.eastTimer > timer + step) {
          this.eastTimer = 0
          this.eastIndex = this.eastIndex + 1
          if (this.eastIndex > 78) {
            this.eastIndex = 1
          }
        }
      }, interval)
    },
    westNext () {
      this.westIndex = this.westIndex + 1
      if (this.westIndex > 81) {
        this.westIndex = 1
      }
      this.westTimer = 0

    },
    eastNext () {
      this.eastIndex = this.eastIndex + 1
      if (this.eastIndex > 78) {
        this.eastIndex = 1
      }
      this.eastTimer = 0

    }
  }
}
</script>


<style lang="stylus">
.slideshow
  display flex
  height 100vh
  .col
    display flex
    flex-direction column
    flex 1
    padding 20px
    .image
      flex 1
      max-height calc(100% - 60px)
      text-align center
      .image-wrap
        display flex
        align-items center
        justify-content center
        flex 1
        height 100%
        overflow hidden
    img
      max-width 100%
      max-height 100%
    &:first-child
      border-right 1px solid #999
    &:last-child
      border-left 1px solid #999
    
  ul
    list-style none
    display flex
    justify-content space-evenly
    
  .timers
    position fixed
    display flex
    bottom 0
    width 100%
    .timer
      height 5px
      flex 1
    
</style>